import { render, staticRenderFns } from "./report-bill.vue?vue&type=template&id=8060a9d2&scoped=true&"
import script from "./report-bill.vue?vue&type=script&lang=js&"
export * from "./report-bill.vue?vue&type=script&lang=js&"
import style0 from "./report-bill.vue?vue&type=style&index=0&id=8060a9d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8060a9d2",
  null
  
)

export default component.exports